export const ru = {
    budget: 'Бюджет, {currency}',
    clicks: 'Клики',
    'clicks-forecast': 'Прогноз кликов',
    cost: 'Расход, {currency}',
    'cost-forecast': 'Прогноз расхода, {currency}',
    name: 'Название кампании',
    'recommended-budget': 'Рекомендуемый бюджет, {currency}',
    status: 'Статус',
    type: 'Тип'
};
